<div class="container">

  <app-header-dialog [iconName]="'store_mall_directory'">
    {{ local_title }}
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-tab-group id='tabs'>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>person</mat-icon>
          Dados
        </ng-template>
        <div class='tab-content'>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              utocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.email"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.email.hasError('required')">
              O email é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>CPF</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.cpf"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.cpf.hasError('required')">
              O CPF é obrigatório.
            </mat-error>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>image_search</mat-icon>
          Imagem
        </ng-template>
        <div class='tab-content'>


          <div class='img-input'>
            <input #file type="file" accept='image/png, image/jpg' style='display:none;'
              (change)="_reportsSubscriptionsService.previewImage($event)" />

            <button mat-raised-button (click)='file.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>

          </div>

          <div class="post-image">
            <img [src]="_reportsSubscriptionsService.storedImage" *ngIf="_reportsSubscriptionsService.storedImage">
          </div>

        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>edit</mat-icon>
          Curriculo
        </ng-template>
        <div class='tab-content'>

          <ckeditor [config]="{ 
            toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="entityForm.controls.text" [editor]="Editor"></ckeditor>

        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>calendar</mat-icon>
          Agenda
        </ng-template>
        <div class='tab-content'>

          <!-- TABLE -->
          <mat-table [dataSource]="dataSource" matSort matSortDisableClear=true>

            <!-- name Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
              <mat-cell *matCellDef="let element">

                <ul>
                  <li *ngIf='element.event_name'>
                    <span style='font-weight: bold; color:rgba(0,0,0,.6);'>{{ element.event_name }}</span>
                  </li>
                  <li *ngIf='element.role_name'>
                    <span style='font-weight: bold; color:rgba(0,0,0,.6);'>{{ element.role_name }}</span>
                  </li>
                  <li *ngIf='element.day_name'>
                    {{element.day_date.seconds*1000 | date: 'dd/MM/yyyy'}} - {{ element.day_name }}
                  </li>
                  <li *ngIf='element.activity_name'>
                    {{ element.activity_startTime }} - {{ element.activity_name }}
                  </li>
                  <li *ngIf='element.topic_name'>
                    <span style='font-weight: bold; color:rgba(0,0,0,.6);'>
                      {{ element.topic_startTime }}
                    </span>
                    - {{ element.topic_name }}
                  </li>
                  <li *ngIf='element.topic_duration'>
                    {{ element.topic_duration }} minutos
                  </li>

                </ul>

              </mat-cell>
            </ng-container>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>
          <!-- END TABLE -->

        </div>
      </mat-tab>

    </mat-tab-group>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button matTooltip='Update' mat-raised-button (click)="matDialogRef.close(['update',entityForm])"
      [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>